export default __webpack_public_path__ + "static/media/022-compass-1.6947bce2.png";